import api from './api';

export interface TokenUsageSummary {
  tokensUsed: number;
  tokenLimit: number;
  remainingTokens: number;
  percentageUsed: number;
  isLimitExceeded: boolean;
  periodStartsAt: string;
  periodEndsAt: string;
  hasUnlimitedCredits: boolean;
}

export const getCurrentTokenUsage = async (): Promise<TokenUsageSummary> => {
  const response = await api.get('/token-usage/current');
  return response.data;
};

